export default "__VITE_ASSET__e729f81b__"